import productReducer from "./productReducer";
import brandReducer from "./brandReducer";
import categoryReducer from "./categoryReducer";
import { combineReducers } from "redux";
import { createMultilanguageReducer } from "redux-multilanguage";
import websiteSettingsReducer from "./websiteSettingsReducer";
import addOnReducer from "./addOnReducer";
import addOnInputsReducer from "./addOnInputsReducer";
import addOnsGroupReducer from "./addOnsGroupReducer";
import cartReducer from "../slices/cartSlice"; // FIXED
import authReducer from "../slices/authSlice";
import { orderCreateReducer } from "./orderReducer";
import wishlistReducer from "../slices/wishlistSlice";  

const rootReducer = combineReducers({
  multilanguage: createMultilanguageReducer({ currentLanguageCode: "he" }),
  productData: productReducer,
  brandsData: brandReducer,
  categoryData: categoryReducer,
  websiteSettingsData: websiteSettingsReducer,
  addOnData: addOnReducer,
  addOnInputsData: addOnInputsReducer,
  addOnsGroupData: addOnsGroupReducer,
  cart: cartReducer, // MUST BE "cart"
  orderCreate: orderCreateReducer,
  wishlist: wishlistReducer,
  auth: authReducer,
});

export default rootReducer;
